export default {
	title: 'application_settings',
	components: [
		{
			title: 'device_card_customization',
			component: 'customize_device_content',
		},
		{ title: 'exclude_event_log', component: 'exclude_event_log' },
	],
};
